import {
    getNanosecondTimestamp,
    stringifyArgs,
} from './logger.utils';
import { ILoggerService } from './logger.interface';
import { IMonitoringStream } from '../../interfaces';
import {
    IMonitoringWithBufferService,
    MONITORING_WITH_BUFFER_SERVICE,
} from '../monitoring-with-buffer';
import { inject, injectable } from 'inversify';
import { OFX_CONFIG } from '../../helpers/app-config';
import { uuidv4 } from '@alk/core';

@injectable()
export class LoggerService implements ILoggerService {

    @inject(MONITORING_WITH_BUFFER_SERVICE) private readonly monitoringSrv: IMonitoringWithBufferService;

    private traceId: string;

    debug = (...args: Array<unknown>): void => {
        !Boolean(this.traceId) && this.init();

        if (OFX_CONFIG.ENABLE_LOG_IN_CONSOLE) {
            // NOTE: The use of the console is mandatory here !
            console.debug(...args);
        }

        const message: IMonitoringStream = {
            timestamp: getNanosecondTimestamp().toString(),
            attributes: {},
            resource: {},
            traceId: this.traceId,
            severityText: 'DEBUG',
            body: stringifyArgs(args),
        };

        this.monitoringSrv.send(message);
    };

    info = (...args: Array<unknown>): void => {
        !Boolean(this.traceId) && this.init();

        if (OFX_CONFIG.ENABLE_LOG_IN_CONSOLE) {
            // NOTE: The use of the console is mandatory here !
            console.info(...args);
        }

        const message: IMonitoringStream = {
            timestamp: getNanosecondTimestamp().toString(),
            attributes: {},
            resource: {},
            traceId: this.traceId,
            severityText: 'INFO',
            body: stringifyArgs(args),
        };

        this.monitoringSrv.send(message);
    };

    warn = (...args: Array<unknown>): void => {
        !Boolean(this.traceId) && this.init();

        if (OFX_CONFIG.ENABLE_LOG_IN_CONSOLE) {
            // NOTE: The use of the console is mandatory here !
            console.warn(...args);
        }

        const message: IMonitoringStream = {
            timestamp: getNanosecondTimestamp().toString(),
            attributes: {},
            resource: {},
            traceId: this.traceId,
            severityText: 'WARN',
            body: stringifyArgs(args),
        };

        this.monitoringSrv.send(message);
    };

    error = (...args: Array<unknown>): void => {
        !Boolean(this.traceId) && this.init();

        if (OFX_CONFIG.ENABLE_LOG_IN_CONSOLE) {
            // NOTE: The use of the console is mandatory here !
            console.error(...args);
        }

        const message: IMonitoringStream = {
            timestamp: getNanosecondTimestamp().toString(),
            attributes: {},
            resource: {},
            traceId: this.traceId,
            severityText: 'ERROR',
            body: stringifyArgs(args),
        };

        this.monitoringSrv.send(message);
    };

    private init() {
        this.traceId = uuidv4();
    }
}
